import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Card, Loader } from 'components';
import { useFetch } from 'hooks';
import { routes } from 'router';
import { setAutolog } from 'store';

const AutologPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { call: loginCall } = useFetch();

  const login = searchParams.get('login');
  const tokenguichet = searchParams.get('tokenguichet');

  useEffect(() => {
    if (login && tokenguichet) {
      logUser();
    } else if (!login && !tokenguichet) {
      navigate(routes.home.path);
    }
  }, [login, tokenguichet]);

  const logUser = async () => {
    const { data } = await loginCall(
      {
        service: 'castelis',
        path: '/authentication/login',
        method: 'post',
        rememberMe: false,
        query: {
          login,
          // Password is not checked in backend when there is a tokenguichet
          password: 'anyPassword',
          tokenguichet
        }
      },
      { hideToast: true }
    );

    if (data.status === 200) {
      dispatch(setAutolog('success'));
      navigate(routes.home.path, { replace: true });
    } else {
      dispatch(setAutolog('failed'));
      navigate(routes.login.path, { replace: true });
    }
  };

  return (
    <Card className="my-8 mx-auto w-[90%] md:w-[25rem]">
      <p className="text-xl text-center font-semibold flex flex-col items-center gap-4">
        <Loader loaderClass="w-5 h-5" />
        <span className="block">{t('auth:autolog.loading')}</span>
      </p>
    </Card>
  );
};

export default AutologPage;
